import { render, staticRenderFns } from "./indexSpyy.vue?vue&type=template&id=8a9d32d6&scoped=true"
import script from "./indexSpyy.vue?vue&type=script&lang=ts"
export * from "./indexSpyy.vue?vue&type=script&lang=ts"
import style0 from "./indexSpyy.vue?vue&type=style&index=0&id=8a9d32d6&prod&lang=scss&scoped=true"
import style1 from "./indexSpyy.vue?vue&type=style&index=1&id=8a9d32d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a9d32d6",
  null
  
)

export default component.exports